import React, { useState, useEffect } from 'react';
import './CurrentProcessCommercialTerms.scss';
import BuyersFeesTable from '../../../AdminMarketplace/MarketplaceTabs/MarketplaceSettings/BuyersFeesTable/BuyersFeesTable';
import {
    LoadMarketplacePricing,
    LoadMarketplaceTemplatePricing,
} from '../../../../slices/marketplace/pricing/load-marketplace-pricing.thunk';
import { useDispatch } from 'react-redux';
import { MarketplacePricing } from '../../../../slices/marketplace/pricing/models/marketplace-pricing.model';
import { BuyersFees } from '../../../../slices/marketplace/pricing/models/buyers-fees-model';
import createNotification from '../../../../utils/createNotification';
import moment from 'moment';
import {
    LevelOfService,
    LevelsOfService,
} from '../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';

interface CurrentProcessCommercialTermsProps {
    engagementId?: number;
    showDateModified?: boolean;
    levelOfService?: LevelOfService;
}
const CurrentProcessCommercialTerms = (
    props: CurrentProcessCommercialTermsProps
) => {
    const dispatch = useDispatch() as any;
    const [settings, setSettings] = useState<MarketplacePricing>();
    const [loading, setLoading] = useState(false);

    const fetchCommercialTerms = async () => {
        setLoading(true);
        try {
            const response = props.engagementId
                ? await dispatch(LoadMarketplacePricing(props.engagementId))
                : await dispatch(LoadMarketplaceTemplatePricing());
            let pricingCopy: MarketplacePricing = JSON.parse(
                JSON.stringify(response.payload.data)
            );
            setSettings(pricingCopy);
        } catch (error) {
            createNotification('Failed to load commercial terms.', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCommercialTerms();
    }, []);

    return (
        <div className="current-process-commercial-terms">
            <div className="body_header_title">
                <h5>
                    {props.engagementId
                        ? 'Buyer Fee Schedule'
                        : 'Connect Fee Schedule'}
                </h5>
            </div>
            <div className="commercial-terms-container">
                {loading ? (
                    <div className="loading-container">
                        <p>Loading commercial terms...</p>
                    </div>
                ) : settings ? (
                    LevelsOfService.filter(
                        (level) =>
                            props.levelOfService === null ||
                            props.levelOfService === undefined ||
                            level.id === props.levelOfService
                    ).map((level, index) => {
                        const maxDateModified = Math.max(
                            new Date(
                                settings.discountBrokeragePricing.buyersFees.dateModified
                            ).getTime(),
                            new Date(
                                settings.fullServiceBrokeragePricing.buyersFees.dateModified
                            ).getTime(),
                            new Date(
                                settings.sfasPricing.buyersFees.dateModified
                            ).getTime()
                        );
                        const pricing =
                            level.id === LevelOfService.DiscountBrokerage
                                ? settings.discountBrokeragePricing
                                : level.id ===
                                  LevelOfService.FullServiceBrokerage
                                ? settings.fullServiceBrokeragePricing
                                : settings.sfasPricing;
                        const pricingKey =
                            level.id === LevelOfService.DiscountBrokerage
                                ? 'discountBrokeragePricing'
                                : level.id ===
                                  LevelOfService.FullServiceBrokerage
                                ? 'fullServiceBrokeragePricing'
                                : 'sfasPricing';
                        return (
                            <>
                                <div className="d-flex justify-content-between align-items-center fees-header">
                                    <h6>{LevelsOfService[level.id].name}</h6>
                                    {!!props.showDateModified && index === 0 ? (
                                        <div>
                                            Date of Last Update:{' '}
                                            {moment(maxDateModified).format(
                                                'l'
                                            )}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <BuyersFeesTable
                                    buyersFees={pricing.buyersFees}
                                    onChange={(newState: BuyersFees) => {}}
                                    setFormFieldValue={() => {}}
                                    formState={settings}
                                    brokerageType={pricingKey}
                                    isViewMode={true}
                                />
                            </>
                        );
                    })
                ) : (
                    []
                )}
            </div>
        </div>
    );
};

export default CurrentProcessCommercialTerms;
